<div class="loan-validation-container">
  <!-- Page Header Component -->
  <app-page-header></app-page-header>

  <div class="page-content">
    <!-- Full Page Loading State -->
    @if (loadingFromAPI) {
      <div class="content-section">
        <div class="evaluation-section-header">
          <div class="evaluation-section-title-wrap">
            <button
              class="section-back-btn"
              (click)="router.navigate(['/home'])"
              title="Back to Dashboard"
              aria-label="Back to Dashboard">
              <svg
                class="back-arrow-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true">
                <path d="M19 12H5"></path>
                <path d="M12 19l-7-7 7-7"></path>
              </svg>
            </button>
            <h2 class="evaluation-section-title">Evaluation</h2>
          </div>
        </div>
        <div class="validation-loading-wrapper">
          <div class="page-loading-state">
            <div class="docsila-loader">
              <div class="beat-loader">
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
              </div>
              <p class="loader-text">Loading document models...</p>
            </div>
          </div>
        </div>
      </div>
    } @else {
    <div class="content-section">
      <div class="evaluation-section-header">
        <div class="evaluation-section-title-wrap">
          <button
            class="section-back-btn"
            (click)="router.navigate(['/home'])"
            title="Back to Dashboard"
            aria-label="Back to Dashboard">
            <svg
              class="back-arrow-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true">
              <path d="M19 12H5"></path>
              <path d="M12 19l-7-7 7-7"></path>
            </svg>
          </button>
          <h2 class="evaluation-section-title">Evaluation</h2>
          <div class="section-search-box" [class.is-disabled]="loanValidations.length === 0" title="Search document models">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="search-icon">
              <circle cx="11" cy="11" r="8"/>
              <line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input type="text" [(ngModel)]="documentSearchTerm" [disabled]="loanValidations.length === 0" placeholder="Search Document Model" class="search-input" />
          </div>
        </div>
      </div>
      @if (loanValidations.length > 0) {
        <div class="validation-table-wrapper">
          <table class="validation-table">
        <thead>
          <tr>
            <th class="sortable doc-model-header" (click)="sortBy('documentCode')">
              <div class="th-with-search">
                <span class="th-label">Document Model <span class="sort-icon" [innerHTML]="getSortIcon('documentCode')"></span></span>
              </div>
            </th>
            <th class="sortable nowrap-header" (click)="sortBy('fileCount')">
              Files <span class="sort-icon" [innerHTML]="getSortIcon('fileCount')"></span>
            </th>
            <th class="sortable compact-header" (click)="sortBy('attributeCount')">
              Attributes <span class="sort-icon" [innerHTML]="getSortIcon('attributeCount')"></span>
            </th>
            <th class="sortable compact-header" (click)="sortBy('groundTruthStatus')">
              Status <span class="sort-icon" [innerHTML]="getSortIcon('groundTruthStatus')"></span>
            </th>
            <th class="sortable" (click)="sortBy('lastRun')">
              Last Run <span class="sort-icon" [innerHTML]="getSortIcon('lastRun')"></span>
            </th>
            <th class="sortable" (click)="sortBy('accuracy')">
              Accuracy <span class="sort-icon" [innerHTML]="getSortIcon('accuracy')"></span>
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (validation of filteredValidations; track validation.id; let i = $index) {
            <tr>
              <td>
                <span class="document-code-single clickable" 
                      (click)="navigateToFacts(validation)" 
                    [title]="validation.loanNumber || 'Click to view facts'">
                  {{ validation.loanNumber }}
                </span>
              </td>
              <td>
                <span class="file-count-badge">{{ validation.fileCount || 0 }}</span>
              </td>
              <td style="text-align: center;">
                <span class="attribute-count-badge">{{ validation.attributeCount || 0 }}</span>
              </td>
              <td style="text-align: center;">
                @if (validation.groundTruthStatus) {
                  <span class="ground-truth-status-badge" 
                        [class]="'ground-truth-status-badge status-' + validation.groundTruthStatus.status.toLowerCase().replace('_', '-')"
                       [title]="validation.groundTruthStatus.message">
                       {{ validation.groundTruthStatus.status.replace('_', ' ') }}
                  </span>
                } @else {
                  <span class="ground-truth-status-badge status-unknown">UNKNOWN</span>
                }
              </td>
              <td>
                @if (validation.lastRun) {
                  <div class="last-run-cell">
                    <div class="run-date">{{ validation.lastRun | date:'mediumDate' }}</div>
                    <div class="run-time">{{ validation.lastRun | date:'shortTime' }}</div>
                  </div>
                } @else {
                  <span class="text-muted">Never run</span>
                }
              </td>
              <td>
                <div class="accuracy-cell">
                  <div class="accuracy-bar">
                    <div 
                      class="accuracy-fill" 
                      [style.width.%]="validation.accuracy"
                      [class.high]="validation.accuracy >= 90"
                      [class.medium]="validation.accuracy >= 75 && validation.accuracy < 90"
                      [class.low]="validation.accuracy < 75">
                    </div>
                  </div>
                  <span class="accuracy-text">{{ validation.accuracy | number:'1.2-2' }}%</span>
                </div>
              </td>
              <td>
                <div class="action-buttons">
                  <!--Eye icon enabled when has active evaluation OR runs > 0 -->
  <button 
    class="btn-action btn-view btn-icon-only" 
    (click)="viewLoanRuns(validation)"
    [disabled]="!isViewRunsEnabled(validation)"
    [title]="getViewRunsTooltip(validation)">
    <span class="material-icons">visibility</span>
  </button>
                                  @if (!authService.isReadOnly) {
                  <button 
                    class="btn-action btn-run btn-icon-only" 
                    [class.needs-evaluation]="needsEvaluationRun(validation.loanNumber) && !isStartingEvaluation(validation.loanNumber) && !hasActiveFullEvaluation(validation.loanNumber)"
                    (click)="runNewValidation(validation)"
                    [disabled]="isStartingEvaluation(validation.loanNumber) || hasActiveFullEvaluation(validation.loanNumber)"
                    [class.btn-loading]="isStartingEvaluation(validation.loanNumber) || hasActiveFullEvaluation(validation.loanNumber)"
                    [title]="getEvaluationRunTooltip(validation.loanNumber)">
                    @if (needsEvaluationRun(validation.loanNumber) && !isStartingEvaluation(validation.loanNumber) && !hasActiveFullEvaluation(validation.loanNumber)) {
                      <span class="evaluation-needed-dot"></span>
                    }
                    @if (isStartingEvaluation(validation.loanNumber) || hasActiveFullEvaluation(validation.loanNumber)) {
                      <div class="btn-spinner"></div>
                    } @else {
                      <span class="material-icons">play_arrow</span>
                    }
                  </button>
                  }
                  @if (authService.isAdmin) {
                    <button 
                      class="btn-action btn-prompt btn-icon-only" 
                      (click)="openPromptTuning(validation)"
                      title="Prompt Tuning">
                      <span class="material-icons">auto_fix_high</span>
                    </button>
                  }
                </div>
              </td>
            </tr>
          }
          @empty {
            <tr>
              <td colspan="7" class="no-results-row">
                <div class="no-results-message">
                  <span class="material-icons">search_off</span>
                  <p>No results found for "{{ documentSearchTerm }}"</p>
                </div>
              </td>
            </tr>
          }
        </tbody>
          </table>
        </div>
      } @else {
        <div class="validation-table-wrapper no-data-wrapper">
          <p class="no-data-text">No data available</p>
        </div>
      }
    </div>
    } <!-- end loadingFromAPI else -->
  </div>

<!-- Runs Modal -->
@if (showRunsModal && selectedValidation) {
  <div class="dialog-overlay" (click)="closeRunsModal()">
    <div class="dialog-content dialog-large" (click)="$event.stopPropagation()">
      <div class="dialog-header">
        <h3>Evaluation Runs - {{ selectedValidation.loanNumber }}</h3>
        <button class="btn-close" (click)="closeRunsModal()">×</button>
      </div>
      <div class="dialog-body">
        <!-- Active Evaluation Status -->
        @if (hasActiveEvaluation(selectedValidation.loanNumber)) {
          <div class="active-evaluation-card">
            <div class="eval-header">
              <span class="eval-badge running">
                <span class="spinner-small"></span>
                Active Evaluation
              </span>
              <span class="eval-id">ID: {{ activeEvaluations.get(selectedValidation.loanNumber)?.evaluation_id }}</span>
            </div>
            <div class="eval-content">
              <div class="metric-circle-section">
                <div class="accuracy-display">
                  <div class="accuracy-circle">
                    <svg viewBox="0 0 36 36" class="circular-chart progress">
                      <circle cx="18" cy="18" r="14" fill="none" stroke="rgba(30,41,59,0.16)" stroke-width="4" pathLength="100"/>
                      <circle cx="18" cy="18" r="14" fill="none" stroke="var(--primary-blue)" stroke-width="4" pathLength="100"
                        [attr.stroke-dasharray]="getEvaluationProgress(selectedValidation.loanNumber) + ' 100'"
                        stroke-dashoffset="0" transform="rotate(-90 18 18)"/>
                    </svg>
                    <span class="accuracy-value">{{ getEvaluationProgress(selectedValidation.loanNumber) }}%</span>
                  </div>
                  <span class="accuracy-label">Progress</span>
                </div>
              </div>

              <div class="details-inline-section">
                <div class="inline-details-row">
                  <span class="inline-detail-item">
                    <span class="inline-detail-label">Document Model</span>
                    <span class="inline-detail-value document-model-value" [title]="selectedValidation.loanNumber || '-'">
                      {{ selectedValidation.loanNumber || '-' }}
                    </span>
                  </span>
                  <span class="inline-detail-item">
                    <span class="inline-detail-label">Status</span>
                    <span class="inline-detail-value status-running">{{ getEvaluationStatusForModel(selectedValidation.loanNumber)?.status || 'STARTING' }}</span>
                  </span>
                  <span class="inline-detail-item">
                    <span class="inline-detail-label">Progress</span>
                    <span class="inline-detail-value">{{ getEvaluationStatusForModel(selectedValidation.loanNumber)?.completed_files || 0 }} / {{ getEvaluationStatusForModel(selectedValidation.loanNumber)?.total_files || 0 }} files</span>
                  </span>
                  @if (currentElapsedTime) {
                  <span class="inline-detail-item">
                    <span class="inline-detail-label">Duration</span>
                    <span class="inline-detail-value">{{ getElapsedTime(selectedValidation.loanNumber) }}</span>
                  </span>
                  }
                </div>
              </div>

              <div class="bar-chart-section">
                <div class="bar-chart-card">
                  <span class="bar-chart-title">Field Status</span>
                  <svg viewBox="0 0 100 20" class="horizontal-bar-chart" aria-label="Matched and Unmatched fields">
                    <rect x="0" y="5" width="100" height="10" rx="5" fill="rgba(30,41,59,0.12)" />
                    @if (getMatchedPercentForModel(selectedValidation.loanNumber) >= 100) {
                      <rect x="0" y="5" width="100" height="10" rx="5" fill="#cfe9f3" />
                    } @else if (getMatchedPercentForModel(selectedValidation.loanNumber) <= 0) {
                      <rect x="0" y="5" width="100" height="10" rx="5" fill="#ffccdd" />
                    } @else {
                      <path [attr.d]="'M 5 5 L ' + getMatchedPercentForModel(selectedValidation.loanNumber) + ' 5 L ' + getMatchedPercentForModel(selectedValidation.loanNumber) + ' 15 L 5 15 A 5 5 0 0 1 0 10 A 5 5 0 0 1 5 5 Z'" fill="#cfe9f3" />
                      <path [attr.d]="'M ' + getMatchedPercentForModel(selectedValidation.loanNumber) + ' 5 L 95 5 A 5 5 0 0 1 100 10 A 5 5 0 0 1 95 15 L ' + getMatchedPercentForModel(selectedValidation.loanNumber) + ' 15 Z'" fill="#ffccdd" />
                    }
                  </svg>
                  <span class="bar-chart-label" style="font-size: 0.75rem; color: white;">{{ getMatchedFieldsForModel(selectedValidation.loanNumber) }} matched {{ getUnmatchedFieldsForModel(selectedValidation.loanNumber) }} unmatched</span>
                </div>
              </div>

              <div class="pie-section">
                <div class="file-status-chart">
                  <div class="pie-chart-mini">
                    <svg viewBox="0 0 36 36" class="circular-chart">
                      <circle cx="18" cy="18" r="9" fill="none" stroke="rgba(30,41,59,0.14)" stroke-width="18" pathLength="100"/>
                      <circle cx="18" cy="18" r="9" fill="none" stroke="#eff6ff" stroke-width="18" pathLength="100"
                        [attr.stroke-dasharray]="getFileStatusDashArrayForModel(selectedValidation.loanNumber, 'completed')"
                        stroke-dashoffset="0" transform="rotate(-90 18 18)"/>
                      <circle cx="18" cy="18" r="9" fill="none" stroke="#22c55e" stroke-width="18" pathLength="100"
                        [attr.stroke-dasharray]="getFileStatusDashArrayForModel(selectedValidation.loanNumber, 'running')"
                        [attr.stroke-dashoffset]="'-' + getFileStatusOffsetForModel(selectedValidation.loanNumber, 'running')" transform="rotate(-90 18 18)"/>
                      <circle cx="18" cy="18" r="9" fill="none" stroke="#ef4444" stroke-width="18" pathLength="100"
                        [attr.stroke-dasharray]="getFileStatusDashArrayForModel(selectedValidation.loanNumber, 'failed')"
                        [attr.stroke-dashoffset]="'-' + getFileStatusOffsetForModel(selectedValidation.loanNumber, 'failed')" transform="rotate(-90 18 18)"/>
                      <circle cx="18" cy="18" r="9" fill="none" stroke="#9ca3af" stroke-width="18" pathLength="100"
                        [attr.stroke-dasharray]="getFileStatusDashArrayForModel(selectedValidation.loanNumber, 'pending')"
                        [attr.stroke-dashoffset]="'-' + getFileStatusOffsetForModel(selectedValidation.loanNumber, 'pending')" transform="rotate(-90 18 18)"/>
                    </svg>
                  </div>
                  <div class="chart-legend">
                    <span class="legend-item"><span class="dot completed"></span><span class="legend-label">Success</span><span class="legend-count">{{ getEvaluationStatusForModel(selectedValidation.loanNumber)?.completed_files || 0 }}</span></span>
                    @if ((getEvaluationStatusForModel(selectedValidation.loanNumber)?.running_files || 0) > 0) {
                      <span class="legend-item"><span class="dot running"></span><span class="legend-label">In Progress</span><span class="legend-count">{{ getEvaluationStatusForModel(selectedValidation.loanNumber)?.running_files }}</span></span>
                    }
                    @if ((getEvaluationStatusForModel(selectedValidation.loanNumber)?.failed_files || 0) > 0) {
                      <span class="legend-item"><span class="dot failed"></span><span class="legend-label">Failed</span><span class="legend-count">{{ getEvaluationStatusForModel(selectedValidation.loanNumber)?.failed_files }}</span></span>
                    }
                    @if ((getEvaluationStatusForModel(selectedValidation.loanNumber)?.pending_files || 0) > 0) {
                      <span class="legend-item"><span class="dot pending"></span><span class="legend-label">Pending</span><span class="legend-count">{{ getEvaluationStatusForModel(selectedValidation.loanNumber)?.pending_files }}</span></span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        } @else {
          <div class="no-active-eval">
            <p>No active evaluation running. Click "Run New Validation" to start one.</p>
          </div>
        }

        <!-- Past Runs Table -->
         <div class="runs-table-wrapper">
          <table class="runs-table">
            <thead>
              <tr>
                <th>Evaluation ID</th>
                <th>Status</th>
                <th>Files</th>
                <th>Duration</th>
                <th>Accuracy</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @if (validationRuns.length === 0) {
                <tr>
                  <td colspan="8" class="no-data">No past evaluation runs found</td>
                </tr>
              }
              @for (run of validationRuns; track run.runId) {
                <tr>
                  <td>
                    <code class="eval-id-code">{{ run.runId }}</code>
                  </td>
                  <td>
                    <span 
                      class="status-badge"
                      [class.completed]="run.status === 'Completed' || run.status === 'COMPLETED'"
                      [class.in-progress]="run.status === 'In Progress' || run.status === 'RUNNING'"
                      [class.failed]="run.status === 'Failed' || run.status === 'FAILED'"
                      [class.pending]="run.status === 'Pending' || run.status === 'PENDING'">
                      {{ run.status }}
                    </span>
                  </td>
                  <td>{{ run.totalFiles ?? '-' }}</td>
                  <td>
                    <span class="duration-text" [title]="run.durationMs ? (run.durationMs / 1000 | number:'1.0-0') + ' seconds' : 'Unknown'">
                      {{ run.duration || '-' }}
                    </span>
                  </td>
                  <td>
                    <span 
                      class="accuracy-badge"
                      [class.high]="run.accuracy >= 90"
                      [class.medium]="run.accuracy >= 75 && run.accuracy < 90"
                      [class.low]="run.accuracy < 75">
                      {{ run.accuracy | number:'1.2-2' }}%
                    </span>
                  </td>
                  <td>{{ run.createdDate | date:'mediumDate' }}</td>
                  <td>{{ run.createdDate | date:'shortTime' }}</td>
                  <td>
                    <button 
                      class="btn-action btn-details" 
                      (click)="viewRunDetails(run)"
                      title="View Details">
                      View Details
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      <div class="dialog-footer">
        <button class="btn-secondary" (click)="closeRunsModal()">Close</button>
        <button class="btn-primary" 
          (click)="runNewValidation(selectedValidation)"
          [disabled]="(selectedValidation.id && isValidationRunning(selectedValidation.id)) || (selectedValidation.loanNumber && hasActiveEvaluation(selectedValidation.loanNumber)) || (selectedValidation.loanNumber && isStartingEvaluation(selectedValidation.loanNumber))">
          @if (selectedValidation.loanNumber && isStartingEvaluation(selectedValidation.loanNumber)) {
            <div class="btn-spinner btn-spinner-light"></div>
            Starting...
          } @else if ((selectedValidation.id && isValidationRunning(selectedValidation.id)) || (selectedValidation.loanNumber && hasActiveEvaluation(selectedValidation.loanNumber))) {
            <div class="btn-spinner btn-spinner-light"></div>
            Running...
          } @else {
            <span class="material-icons">play_arrow</span>
            Run New Validation
          }
        </button>
      </div>
    </div>
  </div>
}

<!-- Add Document Dialog -->
@if (showAddDocumentDialog) {
  <div class="dialog-overlay" (click)="closeAddDocumentDialog()">
    <div class="dialog-content" (click)="$event.stopPropagation()">
      <div class="dialog-header">
        <h3>Add New Document</h3>
        <button class="btn-close" (click)="closeAddDocumentDialog()">×</button>
      </div>
      <div class="dialog-body">
        <div class="form-group">
          <label for="docNumber">Document Code *</label>
          <input 
            type="text" 
            id="docNumber" 
            [(ngModel)]="newDocumentNumber"
            placeholder="e.g., DTSCONDR"
            class="form-control">
        </div>
        <div class="form-group">
          <label for="docName">Document Name *</label>
          <input 
            type="text" 
            id="docName" 
            [(ngModel)]="newDocumentName"
            placeholder="e.g., CONDOMINIUM RIDER"
            class="form-control">
        </div>
        <div class="form-group">
          <label for="docDescription">Description (Optional)</label>
          <textarea 
            id="docDescription" 
            [(ngModel)]="newDocumentDescription"
            placeholder="Additional details about the document"
            rows="3"
            class="form-control"></textarea>
        </div>
      </div>
      <div class="dialog-footer">
        <button class="btn-secondary" (click)="closeAddDocumentDialog()">Cancel</button>
        <button class="btn-primary" (click)="addDocument()">Save Document</button>
      </div>
    </div>
  </div>
}


